import { frontendURL } from '../../../helper/URLHelper';
import NotificationsHubIndex from './pages/NotificationsHubIndex.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/notifications-hub'),
    component: NotificationsHubIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'notifications_hub_index',
        component: NotificationsHubIndex,
        meta: commonMeta,
      },
    ],
  },
];
